import {t} from '@lingui/core/macro';

export interface IMonitorLifecycleTexts {
    paused: string,
    resumed: string,
    deleted: string,
}

export const getMonitorLifecycleTexts = (): IMonitorLifecycleTexts => ({
    paused: t`Монитор поставлен на паузу`,
    resumed: t`Монитор активирован`,
    deleted: t`Монитор удален`,
});
